import { updateOrders } from "../store/actions/ordersSlice";
import store from "../store/store";
import { blue, green, grey, pink, yellow } from "@mui/material/colors";

export const dispatchUpdateOrders = (
  newSearch = false,
  includeNeighborhoodGroups = undefined
) => {
  store.dispatch(updateOrders({ newSearch, includeNeighborhoodGroups }));
};

export const getEventCodeDescription = (code) => {
  switch (code) {
    case "PLC":
      return "Realizada";
    case "CFM":
      return "Aceito";
    case "PKD":
      return "Embalado";
    case "PREDSP":
      return "Clique no botão de despache";
    case "RTP":
      return "Pronto";
    case "OPE":
      return "Carrinho Editado";
    case "OBA":
      return "Desconto Adicionado";
    case "OBR":
      return "Desconto Removido";
    case "DSP":
      return "Despachado";
    case "CART":
      return "Carrinho";
    case "CON":
      return "Entregue";
    case "CAR":
      return "Cancelamento Solicitado";
    case "CCR":
      return "Cancelamento Solicitado pelo Cliente";
    case "CCA":
      return "Solicitação de Cancelamento Aceita";
    case "CAN":
      return "Cancelado";
    case "PAA":
      return "Vaga Informada";
    case "ADR":
      return "Entregador Alocado";
    case "GTO":
      return "Entregador a Caminho da Origem";
    case "AAO":
      return "Entregador Chegou para Retirar o Pedido";
    case "CLT":
      return "Entregador Coletou Pedido";
    case "AAD":
      return "Entregador Chegou no Endereço de Destino";
    case "DRGO":
      return "Entregador Retornando ao Local de Coleta do Pedido";
    case "DRDO":
      return "Devolução";
    case "DCR":
      return "Solicitação de Cancelamento de Entregador";
    case "DDCR":
      return "Recebimento do Código de Confirmação de Entrega";
    case "DDCS":
      return "Código de Confirmação Validado";
    case "DRCR":
      return "Recebimento da Decisão e o Código de Confirmação da Devolução";

    default:
      return code;
  }
};

export const getStatusNumberBackgroundColor = (status) => {
  switch (status) {
    case 0:
      return grey["600"];
    case 1:
      return grey["100"];
    case 2:
    case 44:
      return green["100"];
    case 5:
    case 21:
      return pink["400"];
    case 7:
    case 8:
      return green["100"];
    case 15:
      return yellow["600"];
    case 34:
      return green["500"];
    case 377:
    case 987:
      return grey["700"]; // Cancel
    default:
      return grey["800"]; // Grey
  }
};

export const getStatusNumberColor = (status) => {
  switch (status) {
    case 0:
      return grey["50"];
    case 44:
    case 2:
    case 7:
      return green["700"];
    case 5:
    case 15:
    case 21:
    case 34:
    case 377:
      return grey["50"];
    case 8:
      return blue["400"];
    case 987:
      return grey["500"]; // Cancel
    default:
      return grey["400"]; // Grey
  }
};

export const getStatusNumberIconColor = (status) => {
  switch (status) {
    case 0:
    case 5:
    case 15:
    case 21:
    case 34:
    case 377:
      return "#ffffff";
    case 2:
      return "#2e7d32";
    case 7:
      return blue["800"];
    case 8:
      return blue["600"];
    case 987:
      return "#424242";
    default:
      return "#ffffff";
  }
};

export const getStatusNumberText = (status) => {
  switch (status) {
    case 0:
      return "Aguardando Aprovação";
    case 1:
      return "Confirmação enviada";
    case 2:
      return "Confirmado";
    case 3:
      return "Aguardando confirmação de despache";
    case 5:
      return "A caminho";
    case 7:
      return "Embalado";
    case 8:
      return "Em preparo";
    case 10:
      return "Procurando Entregador";
    case 13:
      return "Aguardando confirmação de Pronto";
    case 15:
      return "Entregador A Caminho";
    case 21:
      return "Pronto para retirada";
    case 34:
      return "Finalizado";
    case 44:
      return "Entrega Confirmada";
    case 55:
      return "Cancelamento Solicitado";
    case 89:
      return "Aguardando cancelamento";
    case 144:
      return "Aguardando cancelamento aceito";
    case 233:
      return "Aguardando cancelamento rejeitado";
    case 377:
      return "Cancelado";
    case 610:
      return "Retornando";
    case 987:
      return "Devolvido";
    default:
      return "";
  }
};

export const getOrderCancelReason = (reason) => {
  switch (reason) {
    case "Handshake Order Late":
      return "Pedido Atrasado";

    default:
      return reason;
  }
};

export const isOrderDispatchLate = (delivery_expected_time) => {
  const orderDeliveryExpectedTime = new Date(delivery_expected_time);
  const now = new Date();

  const differenceInMinutes = (orderDeliveryExpectedTime - now) / (1000 * 60);

  return differenceInMinutes < 0;
};

export const calculateRadius = (distance) => Math.ceil(distance / 1000);
